import { create } from 'zustand'
import {
  AccessRequest,
  AccessRequestStatus,
  listAccessRequests,
  getErrorMessage,
} from '../api/accessRequestsApi'

interface AccessRequestsState {
  requests: AccessRequest[]
  total: number
  page: number
  pages: number
  pageSize: number
  isLoading: boolean
  error: string | null

  // Filter state
  statusFilter: AccessRequestStatus | null

  // Actions
  fetchRequests: () => Promise<void>
  setPage: (page: number) => void
  setPageSize: (pageSize: number) => void
  setStatusFilter: (status: AccessRequestStatus | null) => void
  clearError: () => void
}

export const useAccessRequestsStore = create<AccessRequestsState>()((set, get) => ({
  requests: [],
  total: 0,
  page: 1,
  pages: 0,
  pageSize: 20,
  isLoading: false,
  error: null,
  statusFilter: 'pending',

  fetchRequests: async () => {
    const { page, pageSize, statusFilter } = get()
    set({ isLoading: true, error: null })

    try {
      const response = await listAccessRequests({
        page,
        limit: pageSize,
        status: statusFilter || undefined,
      })
      set({
        requests: response.requests,
        total: response.total,
        page: response.page,
        pages: response.pages,
        isLoading: false,
      })
    } catch (error) {
      set({ error: getErrorMessage(error), isLoading: false })
    }
  },

  setPage: (page: number) => {
    set({ page })
    get().fetchRequests()
  },

  setPageSize: (pageSize: number) => {
    set({ pageSize, page: 1 })
    get().fetchRequests()
  },

  setStatusFilter: (status: AccessRequestStatus | null) => {
    set({ statusFilter: status, page: 1 })
    get().fetchRequests()
  },

  clearError: () => set({ error: null }),
}))
